// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/materialized_aggregate_tiles.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AggregateTimeSeries } from "../../aggregate/v1/timeseries_pb";
import { file_chalk_aggregate_v1_timeseries } from "../../aggregate/v1/timeseries_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/materialized_aggregate_tiles.proto.
 */
export const file_chalk_server_v1_materialized_aggregate_tiles: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_aggregate_v1_timeseries, file_google_protobuf_timestamp]);

/**
 * One tile's coverage interval. Full manifests are fetched on demand via
 * ListMaterializedAggregateTilesForTimeline.
 *
 * @generated from message chalk.server.v1.MaterializedAggregateTileTimelineInterval
 */
export type MaterializedAggregateTileTimelineInterval = Message<"chalk.server.v1.MaterializedAggregateTileTimelineInterval"> & {
  /**
   * @generated from field: google.protobuf.Timestamp coverage_lower_bound = 1;
   */
  coverageLowerBound?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp coverage_upper_bound = 2;
   */
  coverageUpperBound?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.MaterializedAggregateTileTimelineInterval.
 * Use `create(MaterializedAggregateTileTimelineIntervalSchema)` to create a new message.
 */
export const MaterializedAggregateTileTimelineIntervalSchema: GenMessage<MaterializedAggregateTileTimelineInterval> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 0);

/**
 * One timeline corresponds to one materialization_key_hash.
 * group_by is the comma-joined display form; the structured columns live on MaterializedAggregateTileMeta.
 *
 * @generated from message chalk.server.v1.MaterializedAggregateTileTimeline
 */
export type MaterializedAggregateTileTimeline = Message<"chalk.server.v1.MaterializedAggregateTileTimeline"> & {
  /**
   * @generated from field: string materialization_key_hash = 1;
   */
  materializationKeyHash: string;

  /**
   * @generated from field: string aggregation = 2;
   */
  aggregation: string;

  /**
   * @generated from field: string aggregate_on = 3;
   */
  aggregateOn: string;

  /**
   * @generated from field: string group_by = 4;
   */
  groupBy: string;

  /**
   * @generated from field: string bucket_on = 5;
   */
  bucketOn: string;

  /**
   * @generated from field: chalk.server.v1.MaterializedAggregateTileTimelineInterval coverage = 6;
   */
  coverage?: MaterializedAggregateTileTimelineInterval;

  /**
   * @generated from field: repeated chalk.server.v1.MaterializedAggregateTileTimelineInterval intervals = 8;
   */
  intervals: MaterializedAggregateTileTimelineInterval[];

  /**
   * Distinguishes timelines that are otherwise identical in the four display fields above.
   * Milliseconds, not Duration: the sibling MaterializedAggregateTileMeta and the facet both use ms.
   *
   * @generated from field: int64 bucket_duration_ms = 9;
   */
  bucketDurationMs: bigint;

  /**
   * Windowed features of the active deployment that read this series; empty without a mapping.
   *
   * @generated from field: repeated chalk.server.v1.TileReadingFeature reading_features = 10;
   */
  readingFeatures: TileReadingFeature[];
};

/**
 * Describes the message chalk.server.v1.MaterializedAggregateTileTimeline.
 * Use `create(MaterializedAggregateTileTimelineSchema)` to create a new message.
 */
export const MaterializedAggregateTileTimelineSchema: GenMessage<MaterializedAggregateTileTimeline> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 1);

/**
 * @generated from message chalk.server.v1.TileReadingFeature
 */
export type TileReadingFeature = Message<"chalk.server.v1.TileReadingFeature"> & {
  /**
   * The base feature, e.g. `user.spend` for `user.spend__604800__`.
   *
   * @generated from field: string fqn = 1;
   */
  fqn: string;

  /**
   * The window features the engine reports, e.g. `user.spend__604800__`, sorted.
   *
   * @generated from field: repeated string windowed_features = 2;
   */
  windowedFeatures: string[];

  /**
   * Tile series this feature reads in total; a backfill of it writes them all.
   *
   * @generated from field: int32 series_count = 3;
   */
  seriesCount: number;
};

/**
 * Describes the message chalk.server.v1.TileReadingFeature.
 * Use `create(TileReadingFeatureSchema)` to create a new message.
 */
export const TileReadingFeatureSchema: GenMessage<TileReadingFeature> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 2);

/**
 * Pagination is by timeline group, so a returned group is always full.
 * coverage is the group-wide MIN/MAX.
 *
 * @generated from message chalk.server.v1.MaterializedAggregateTileTimelineGroup
 */
export type MaterializedAggregateTileTimelineGroup = Message<"chalk.server.v1.MaterializedAggregateTileTimelineGroup"> & {
  /**
   * @generated from field: string aggregate_on = 1;
   */
  aggregateOn: string;

  /**
   * @generated from field: repeated chalk.server.v1.MaterializedAggregateTileTimeline timelines = 2;
   */
  timelines: MaterializedAggregateTileTimeline[];

  /**
   * @generated from field: chalk.server.v1.MaterializedAggregateTileTimelineInterval coverage = 3;
   */
  coverage?: MaterializedAggregateTileTimelineInterval;
};

/**
 * Describes the message chalk.server.v1.MaterializedAggregateTileTimelineGroup.
 * Use `create(MaterializedAggregateTileTimelineGroupSchema)` to create a new message.
 */
export const MaterializedAggregateTileTimelineGroupSchema: GenMessage<MaterializedAggregateTileTimelineGroup> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 3);

/**
 * Filter parameters for ListMaterializedAggregateTileTimelines.
 *
 * @generated from message chalk.server.v1.ListMaterializedAggregateTileTimelinesFilter
 */
export type ListMaterializedAggregateTileTimelinesFilter = Message<"chalk.server.v1.ListMaterializedAggregateTileTimelinesFilter"> & {
  /**
   * Case-insensitive prefix match on aggregate_on. Unset or empty matches all.
   *
   * @generated from field: optional string aggregate_on_prefix = 1;
   */
  aggregateOnPrefix?: string;

  /**
   * Faceted-search query over tileFacetRegistry keys, e.g. `aggregation:sum -bucket_on:ts`.
   * Keyed terms match exactly, repeated keys OR within their facet, and bare terms are a
   * case-insensitive substring match on aggregate_on. OR across facets is rejected.
   *
   * @generated from field: optional string query = 2;
   */
  query?: string;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTileTimelinesFilter.
 * Use `create(ListMaterializedAggregateTileTimelinesFilterSchema)` to create a new message.
 */
export const ListMaterializedAggregateTileTimelinesFilterSchema: GenMessage<ListMaterializedAggregateTileTimelinesFilter> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 4);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTileTimelinesRequest
 */
export type ListMaterializedAggregateTileTimelinesRequest = Message<"chalk.server.v1.ListMaterializedAggregateTileTimelinesRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * Server default is 10 if unset.
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional chalk.server.v1.ListMaterializedAggregateTileTimelinesFilter filter = 3;
   */
  filter?: ListMaterializedAggregateTileTimelinesFilter;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTileTimelinesRequest.
 * Use `create(ListMaterializedAggregateTileTimelinesRequestSchema)` to create a new message.
 */
export const ListMaterializedAggregateTileTimelinesRequestSchema: GenMessage<ListMaterializedAggregateTileTimelinesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 5);

/**
 * @generated from message chalk.server.v1.ListMaterializedAggregateTileTimelinesResponse
 */
export type ListMaterializedAggregateTileTimelinesResponse = Message<"chalk.server.v1.ListMaterializedAggregateTileTimelinesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.MaterializedAggregateTileTimelineGroup timeline_groups = 1;
   */
  timelineGroups: MaterializedAggregateTileTimelineGroup[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListMaterializedAggregateTileTimelinesResponse.
 * Use `create(ListMaterializedAggregateTileTimelinesResponseSchema)` to create a new message.
 */
export const ListMaterializedAggregateTileTimelinesResponseSchema: GenMessage<ListMaterializedAggregateTileTimelinesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 6);

/**
 * @generated from message chalk.server.v1.TileFacet
 */
export type TileFacet = Message<"chalk.server.v1.TileFacet"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: chalk.server.v1.TileFacetType facet_type = 3;
   */
  facetType: TileFacetType;
};

/**
 * Describes the message chalk.server.v1.TileFacet.
 * Use `create(TileFacetSchema)` to create a new message.
 */
export const TileFacetSchema: GenMessage<TileFacet> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 7);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileFacetsRequest
 */
export type GetMaterializedAggregateTileFacetsRequest = Message<"chalk.server.v1.GetMaterializedAggregateTileFacetsRequest"> & {
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileFacetsRequest.
 * Use `create(GetMaterializedAggregateTileFacetsRequestSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileFacetsRequestSchema: GenMessage<GetMaterializedAggregateTileFacetsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 8);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileFacetsResponse
 */
export type GetMaterializedAggregateTileFacetsResponse = Message<"chalk.server.v1.GetMaterializedAggregateTileFacetsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.TileFacet facets = 1;
   */
  facets: TileFacet[];
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileFacetsResponse.
 * Use `create(GetMaterializedAggregateTileFacetsResponseSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileFacetsResponseSchema: GenMessage<GetMaterializedAggregateTileFacetsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 9);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileFacetValuesRequest
 */
export type GetMaterializedAggregateTileFacetValuesRequest = Message<"chalk.server.v1.GetMaterializedAggregateTileFacetValuesRequest"> & {
  /**
   * Canonical snake_case facet key, as in tileFacetRegistry. Empty returns every facet's values.
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * Per-facet cap on returned values, highest count first. Server default is 100 if unset.
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * Counts reflect this filter, so the caller sees what a further narrowing would yield.
   *
   * @generated from field: optional chalk.server.v1.ListMaterializedAggregateTileTimelinesFilter filter = 3;
   */
  filter?: ListMaterializedAggregateTileTimelinesFilter;

  /**
   * Case-insensitive substring match on values, applied before `limit`. Unset or empty matches all.
   *
   * @generated from field: optional string value_search = 4;
   */
  valueSearch?: string;
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileFacetValuesRequest.
 * Use `create(GetMaterializedAggregateTileFacetValuesRequestSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileFacetValuesRequestSchema: GenMessage<GetMaterializedAggregateTileFacetValuesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 10);

/**
 * @generated from message chalk.server.v1.TileTimelineFacetValue
 */
export type TileTimelineFacetValue = Message<"chalk.server.v1.TileTimelineFacetValue"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * Bucket durations arrive as the stringified millisecond value; the client formats the label.
   *
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * Distinct timelines carrying this value, not tiles.
   *
   * @generated from field: int64 count = 3;
   */
  count: bigint;
};

/**
 * Describes the message chalk.server.v1.TileTimelineFacetValue.
 * Use `create(TileTimelineFacetValueSchema)` to create a new message.
 */
export const TileTimelineFacetValueSchema: GenMessage<TileTimelineFacetValue> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 11);

/**
 * @generated from message chalk.server.v1.GetMaterializedAggregateTileFacetValuesResponse
 */
export type GetMaterializedAggregateTileFacetValuesResponse = Message<"chalk.server.v1.GetMaterializedAggregateTileFacetValuesResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.TileTimelineFacetValue values = 1;
   */
  values: TileTimelineFacetValue[];
};

/**
 * Describes the message chalk.server.v1.GetMaterializedAggregateTileFacetValuesResponse.
 * Use `create(GetMaterializedAggregateTileFacetValuesResponseSchema)` to create a new message.
 */
export const GetMaterializedAggregateTileFacetValuesResponseSchema: GenMessage<GetMaterializedAggregateTileFacetValuesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 12);

/**
 * @generated from message chalk.server.v1.TileSeriesSummary
 */
export type TileSeriesSummary = Message<"chalk.server.v1.TileSeriesSummary"> & {
  /**
   * @generated from field: string materialization_key_hash = 1;
   */
  materializationKeyHash: string;

  /**
   * Rule aggregations stored under this key, e.g. a mean's `count` and `sum`.
   *
   * @generated from field: repeated string aggregations = 2;
   */
  aggregations: string[];

  /**
   * @generated from field: int64 bucket_duration_ms = 3;
   */
  bucketDurationMs: bigint;

  /**
   * @generated from field: repeated chalk.server.v1.TileReadingFeature reading_features = 4;
   */
  readingFeatures: TileReadingFeature[];
};

/**
 * Describes the message chalk.server.v1.TileSeriesSummary.
 * Use `create(TileSeriesSummarySchema)` to create a new message.
 */
export const TileSeriesSummarySchema: GenMessage<TileSeriesSummary> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 13);

/**
 * A materialized aggregation of the active deployment, with its tile series.
 *
 * @generated from message chalk.server.v1.FeatureMaterializedAggregation
 */
export type FeatureMaterializedAggregation = Message<"chalk.server.v1.FeatureMaterializedAggregation"> & {
  /**
   * @generated from field: chalk.aggregate.v1.AggregateTimeSeries series = 1;
   */
  series?: AggregateTimeSeries;

  /**
   * One per distinct rule key; empty for series with no tiles, e.g. expression projections.
   *
   * @generated from field: repeated chalk.server.v1.TileSeriesSummary tile_series = 2;
   */
  tileSeries: TileSeriesSummary[];
};

/**
 * Describes the message chalk.server.v1.FeatureMaterializedAggregation.
 * Use `create(FeatureMaterializedAggregationSchema)` to create a new message.
 */
export const FeatureMaterializedAggregationSchema: GenMessage<FeatureMaterializedAggregation> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 14);

/**
 * @generated from message chalk.server.v1.GetFeatureMaterializedAggregationsRequest
 */
export type GetFeatureMaterializedAggregationsRequest = Message<"chalk.server.v1.GetFeatureMaterializedAggregationsRequest"> & {
  /**
   * A windowed child such as `user.spend__604800__` resolves to its base feature.
   *
   * @generated from field: string feature_fqn = 1;
   */
  featureFqn: string;
};

/**
 * Describes the message chalk.server.v1.GetFeatureMaterializedAggregationsRequest.
 * Use `create(GetFeatureMaterializedAggregationsRequestSchema)` to create a new message.
 */
export const GetFeatureMaterializedAggregationsRequestSchema: GenMessage<GetFeatureMaterializedAggregationsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 15);

/**
 * @generated from message chalk.server.v1.GetFeatureMaterializedAggregationsResponse
 */
export type GetFeatureMaterializedAggregationsResponse = Message<"chalk.server.v1.GetFeatureMaterializedAggregationsResponse"> & {
  /**
   * Series this feature's windows are computed from.
   *
   * @generated from field: repeated chalk.server.v1.FeatureMaterializedAggregation computing = 1;
   */
  computing: FeatureMaterializedAggregation[];

  /**
   * Series that read this feature as an input: aggregated, projected, filtered, grouped or bucketed on.
   *
   * @generated from field: repeated chalk.server.v1.FeatureMaterializedAggregation reading = 2;
   */
  reading: FeatureMaterializedAggregation[];

  /**
   * Aggregations the engine failed to parse.
   *
   * @generated from field: repeated string errors = 3;
   */
  errors: string[];

  /**
   * @generated from field: chalk.server.v1.TileFeatureMappingStatus mapping_status = 4;
   */
  mappingStatus: TileFeatureMappingStatus;
};

/**
 * Describes the message chalk.server.v1.GetFeatureMaterializedAggregationsResponse.
 * Use `create(GetFeatureMaterializedAggregationsResponseSchema)` to create a new message.
 */
export const GetFeatureMaterializedAggregationsResponseSchema: GenMessage<GetFeatureMaterializedAggregationsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 16);

/**
 * One tile series of a feature that has tiles.
 *
 * @generated from message chalk.server.v1.TileSeriesCoverage
 */
export type TileSeriesCoverage = Message<"chalk.server.v1.TileSeriesCoverage"> & {
  /**
   * @generated from field: string materialization_key_hash = 1;
   */
  materializationKeyHash: string;

  /**
   * @generated from field: int64 bucket_duration_ms = 2;
   */
  bucketDurationMs: bigint;

  /**
   * From the series' first tile to its last.
   *
   * @generated from field: chalk.server.v1.MaterializedAggregateTileTimelineInterval coverage = 3;
   */
  coverage?: MaterializedAggregateTileTimelineInterval;

  /**
   * Holes between its tiles, sorted.
   *
   * @generated from field: repeated chalk.server.v1.MaterializedAggregateTileTimelineInterval gaps = 4;
   */
  gaps: MaterializedAggregateTileTimelineInterval[];

  /**
   * @generated from field: int32 tile_count = 5;
   */
  tileCount: number;
};

/**
 * Describes the message chalk.server.v1.TileSeriesCoverage.
 * Use `create(TileSeriesCoverageSchema)` to create a new message.
 */
export const TileSeriesCoverageSchema: GenMessage<TileSeriesCoverage> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 17);

/**
 * @generated from message chalk.server.v1.TileFeatureCoverage
 */
export type TileFeatureCoverage = Message<"chalk.server.v1.TileFeatureCoverage"> & {
  /**
   * @generated from field: string fqn = 1;
   */
  fqn: string;

  /**
   * @generated from field: repeated string windowed_features = 2;
   */
  windowedFeatures: string[];

  /**
   * Only series with tiles; a feature with none is omitted from the listing.
   *
   * @generated from field: repeated chalk.server.v1.TileSeriesCoverage series = 3;
   */
  series: TileSeriesCoverage[];
};

/**
 * Describes the message chalk.server.v1.TileFeatureCoverage.
 * Use `create(TileFeatureCoverageSchema)` to create a new message.
 */
export const TileFeatureCoverageSchema: GenMessage<TileFeatureCoverage> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 18);

/**
 * @generated from message chalk.server.v1.ListTileFeatureCoverageFilters
 */
export type ListTileFeatureCoverageFilters = Message<"chalk.server.v1.ListTileFeatureCoverageFilters"> & {
  /**
   * Case-insensitive substring match on the feature fqn. Unset or empty matches all.
   *
   * @generated from field: optional string fqn_search = 1;
   */
  fqnSearch?: string;

  /**
   * Exact base features, e.g. for one feature's drawer or page; a window name resolves to its base.
   *
   * @generated from field: repeated string feature_fqns = 2;
   */
  featureFqns: string[];
};

/**
 * Describes the message chalk.server.v1.ListTileFeatureCoverageFilters.
 * Use `create(ListTileFeatureCoverageFiltersSchema)` to create a new message.
 */
export const ListTileFeatureCoverageFiltersSchema: GenMessage<ListTileFeatureCoverageFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 19);

/**
 * @generated from message chalk.server.v1.ListTileFeatureCoverageRequest
 */
export type ListTileFeatureCoverageRequest = Message<"chalk.server.v1.ListTileFeatureCoverageRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * Server default is 50 if unset.
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional chalk.server.v1.ListTileFeatureCoverageFilters filters = 3;
   */
  filters?: ListTileFeatureCoverageFilters;
};

/**
 * Describes the message chalk.server.v1.ListTileFeatureCoverageRequest.
 * Use `create(ListTileFeatureCoverageRequestSchema)` to create a new message.
 */
export const ListTileFeatureCoverageRequestSchema: GenMessage<ListTileFeatureCoverageRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 20);

/**
 * @generated from message chalk.server.v1.ListTileFeatureCoverageResponse
 */
export type ListTileFeatureCoverageResponse = Message<"chalk.server.v1.ListTileFeatureCoverageResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.TileFeatureCoverage features = 1;
   */
  features: TileFeatureCoverage[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;

  /**
   * Features are listed only when this is AVAILABLE.
   *
   * @generated from field: chalk.server.v1.TileFeatureMappingStatus mapping_status = 3;
   */
  mappingStatus: TileFeatureMappingStatus;
};

/**
 * Describes the message chalk.server.v1.ListTileFeatureCoverageResponse.
 * Use `create(ListTileFeatureCoverageResponseSchema)` to create a new message.
 */
export const ListTileFeatureCoverageResponseSchema: GenMessage<ListTileFeatureCoverageResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_materialized_aggregate_tiles, 21);

/**
 * Parallels LogFacetType / KubeEventFacetType / SpanFacetType, which share these numeric values.
 *
 * @generated from enum chalk.server.v1.TileFacetType
 */
export enum TileFacetType {
  /**
   * @generated from enum value: TILE_FACET_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TILE_FACET_TYPE_LIST = 1;
   */
  LIST = 1,
}

/**
 * Describes the enum chalk.server.v1.TileFacetType.
 */
export const TileFacetTypeSchema: GenEnum<TileFacetType> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_materialized_aggregate_tiles, 0);

/**
 * Whether the active deployment can map features to tile series.
 *
 * @generated from enum chalk.server.v1.TileFeatureMappingStatus
 */
export enum TileFeatureMappingStatus {
  /**
   * @generated from enum value: TILE_FEATURE_MAPPING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TILE_FEATURE_MAPPING_STATUS_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * The environment has no active deployment to ask.
   *
   * @generated from enum value: TILE_FEATURE_MAPPING_STATUS_NO_ACTIVE_DEPLOYMENT = 2;
   */
  NO_ACTIVE_DEPLOYMENT = 2,

  /**
   * The active engine predates rule tile keys; aggregation definitions are still returned.
   *
   * @generated from enum value: TILE_FEATURE_MAPPING_STATUS_ENGINE_UNSUPPORTED = 3;
   */
  ENGINE_UNSUPPORTED = 3,
}

/**
 * Describes the enum chalk.server.v1.TileFeatureMappingStatus.
 */
export const TileFeatureMappingStatusSchema: GenEnum<TileFeatureMappingStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_materialized_aggregate_tiles, 1);

